<template>
  <div>
    <div
      class="bg-white shadow-sm rounded-md h-60 overflow-x-auto lg:mx-0 mx-3"
    >
      <div class="border-b-0.5 flex justify-between items-center">
        <p class="p-2 text-sm">Celebrations</p>
        <!-- <router-link
          v-tooltip="'You have new messages.'"
          :to="{ name: 'announcements' }"
        >
          <img class="h-4 cursor-pointer pr-2" src="@/assets/icons/add.png" />
        </router-link> -->
      </div>
      <div class="flex flex-col gap-y-1 p-2" v-if="items.length">
        <div
          :class="open == index ? 'border-1.5 rounded-md' : 'border-none'"
          v-for="(item, index) in items"
          :key="index"
        >
          <div
            class="flex justify-between gap-4 p-3 items-center cursor-pointer hover:bg-gray-100 border-b-0.5"
          >
            <div
              class="flex justify-start gap-4 p-3 items-center cursor-pointer hover:bg-gray-100"
            >
              <div
                class="h-8 w-8 rounded-full bg-gray-400 flex items-center justify-center"
              >
                <img
                  v-if="item.image"
                  class="h-full w-full rounded-full object-cover"
                  :src="item.image"
                  :alt="getInitials(item.Name)"
                />

                <span class="text-white" v-else>
                  {{ getInitials(item.Name) }}
                </span>
              </div>

              <div class="text-xs">
                <p class="font-bold">
                  {{ decryptDataLocal(item.Name, $decryptionKey) }}
                </p>
                <span>{{ item.Celebration }}</span>
                <p class="rounded-sm mt-1 font-bold">
                  {{
                    new Date(item.Date).toLocaleDateString("en-US", {
                      month: "long",
                      day: "numeric",
                    })
                  }}
                </p>
              </div>
            </div>
            <div class="h-10 w-10">
              <img
                v-if="item.Celebration.toLowerCase() === 'birthday'"
                src="@/assets/icons/birthday.png"
                alt=""
                srcset=""
                class="animate-pulse"
              />
              <img
                v-if="item.Celebration.toLowerCase() === 'anniversary'"
                src="@/assets/icons/anniversary.png"
                alt=""
                srcset=""
                class="animate-pulse"
              />
            </div>
          </div>
          <transition name="accordion">
            <p
              v-if="open == index"
              class="px-1.5 p-2"
              style="font-size: 0.8rem !important"
            >
              {{ item.Celebration }}
            </p>
          </transition>
        </div>
      </div>

      <div class="max-h-screen px-4" v-else>
        <div
          v-if="!loading || items.length === 0"
          class="flex flex-col justify-center items-center h-full mt-5"
        >
          <el-empty :image-size="70" description="No Data"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import decryptData from "@/utils/decrypt";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "Celebrations",
  data() {
    return {
      decryptDataLocal: "",
      key: "",
      open: null,
      items: [],
    };
  },
  created() {
    this.decryptDataLocal = decryptData;
    this.getCelebrations();
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },

  methods: {
    getInitials(fullname) {
      const decrytedEmployeeName = decryptData(fullname, this.$decryptionKey);
      const names = decrytedEmployeeName?.split(" ").slice(0, 2);
      return names
        .map((name) => name[0])
        .join("")
        .toUpperCase();
    },
    view(index) {
      if (index == this.open) {
        this.open = null;
      } else {
        this.open = index;
      }
    },
    // /dashboard/birthdates/v1/upcoming
    getCelebrations() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/dashboard/birthdates/${this.$ApiVersion}/upcoming`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.items = response.data.Data;

              // Sort the items based on the Date attribute
              this.items.sort((a, b) => {
                const dateA = new Date(a.Date);
                const dateB = new Date(b.Date);
                return dateA - dateB;
              });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>
